module.exports = __webpack_public_path__ + "img/MCO-alt.791c8bb0.svg";